/**
 * V27 (idea from BuildMyPOD 2.0 "auto-fit title to one line"): the product page title
 * stays on ONE line on every screen, shrinking its own font until it fits, so a long
 * title never pushes the Add to cart button down a line on a phone.
 *
 * The one-line commitment is CSS (layout/theme.liquid, same selector) so there is no
 * two-line flash before this runs; this only shrinks the font, never grows it.
 * Floor: MIN_PX. A title that still does not fit at the floor (45+ characters on a
 * narrow phone) wraps at the floor size instead of getting unreadable.
 *
 * Targets the "Product Title" text block of templates/product.json (text_N6TEWF). If that
 * block is ever replaced, nothing breaks - the title just wraps like before.
 */
(() => {
  const SELECTOR = '[class*="text_N6TEWF"] :is(h1, h2, h3, p)';
  const MIN_PX = 15;
  // aim 2px inside the box: widths come back rounded, so an exact fit can clip the last glyph
  const SLACK = 2;

  // phones only - matches the @media in layout/theme.liquid
  const phone = window.matchMedia('(max-width: 749px)');

  /** @param {HTMLElement} el */
  function fit(el) {
    el.style.removeProperty('font-size');
    el.classList.remove('tgc-title-fit--wrap');
    if (!phone.matches) return;
    const base = parseFloat(getComputedStyle(el).fontSize);
    const available = el.clientWidth - SLACK;
    const needed = el.scrollWidth;
    if (!available || needed <= available + SLACK) return;

    // 'important': the phone title size is itself set with !important elsewhere
    const size = Math.floor(((base * available) / needed) * 10) / 10;
    if (size < MIN_PX) {
      el.style.setProperty('font-size', `${MIN_PX}px`, 'important');
      el.classList.add('tgc-title-fit--wrap');
      return;
    }
    el.style.setProperty('font-size', `${size}px`, 'important');
  }

  function fitAll() {
    document.querySelectorAll(SELECTOR).forEach((el) => fit(/** @type {HTMLElement} */ (el)));
  }

  let frame = 0;
  const schedule = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(fitAll);
  };

  fitAll();
  // the real web font arrives after first paint and is wider or narrower than the fallback
  document.fonts?.ready.then(schedule);
  // a colour change re-renders the product section and drops the inline font size
  document.addEventListener('variant:update', () => setTimeout(schedule, 50));
  const observer = new ResizeObserver(schedule);
  document.querySelectorAll(SELECTOR).forEach((el) => observer.observe(el.parentElement || el));
})();
